<template>
  <div class="row mt-3">
    <div class="col-md-4 px-2 d-none d-md-block">
      <div class="card">
        <div class="card-body">
          <current-user :user="current_user" />
        </div>
      </div>
    </div>
    <div class="col-md-8 px-2">
      <div class="card mb-3" v-if="is_current_user_page || is_profile_page">
        <div class="card-body">
          <a href="/users/profile" v-if="is_current_user_page">
            <i class="fas fa-user"></i>
            自分のまぐを全て見る
          </a>
          <span v-if="is_profile_page">
            <i class="fas fa-lock" style="color: goldenrod"></i>
            このページは自分だけが見られます
          </span>
        </div>
      </div>
      <div class="card mb-3" v-if="!current_user">
        <div class="card-body">
          <pr :show-timeline-button="true" />
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <profile :user="user" :is-current-user-page="is_current_user_page" :is-profile-page="is_profile_page" />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <timeline :current-user="current_user" :is-profile-page="is_profile_page" :target-user-ids="user.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentUser from './_current_user'
import Profile from './_profile'
import Timeline from '../mags/_timeline'
import Pr from './_pr'
import Chart from '../charts/_show'

export default {
  components: { CurrentUser, Profile, Timeline, Pr, Chart },
  props: ['current_user', 'user', 'is_profile_page', 'is_current_user_page'],
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
